import { useGetPlans } from 'common/queries-and-mutations/payment';
import IWillPlanMobile from 'components/IWillPlanMobile';
import React from 'react';

export default function PlanMobile() {
  const { data: plans } = useGetPlans();

  return (
    <div className="w-full flex-col items-center justify-center bg-white px-10 sm:flex md:mt-10 md:hidden">
      <div className="text-center">
        <p className="font-circular text-lg font-normal leading-tight text-[#1E063E]">
          Plans Prepared For
        </p>
        <p className="font-circular text-lg font-normal leading-tight text-[#1E063E]">
          You By Us
        </p>
      </div>

      <div className="mt-4 grid grid-cols-12 gap-4 py-5 sm:mt-5 sm:gap-5 lg:mt-6 lg:gap-6">
        <div className="col-span-12 flex space-x-4 overflow-x-auto px-[var(--margin-x)] transition-all duration-[.25s] scrollbar-hide lg:pl-0">
          <div className="shrink-0 space-y-9 rounded-xl p-4 sm:px-5">
            <div className="flex flex-row items-center gap-5">
              {(plans ?? []).map(plan => (
                <IWillPlanMobile
                  key={plan.planId}
                  iWillLogo={plan.image}
                  iWillPrice={plan.price}
                  iWillPackages={plan.packages}
                  iWillPlanId={plan.planId}
                  isRecommended={!!plan.isRecommended}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
